import React, { useState } from "react";
import styles from "./style.module.scss";
import { ReactComponent as LikeIcon } from "@/assets/icons/mySpace/like.svg";
import { ReactComponent as IsLikingIcon } from "@/assets/icons/mySpace/liking.svg";
import { setLike, setUnLike } from "../../api/mySpace";

const IMG_COMPRESSION_W = 300;

const URL_IDX_MAP = {
  REELS: "image_url",
  LIKE: "image_url",
  SOMETHING: "SOMETHING",
};

const TITLE_IDX_MAP = {
  REELS: "opus_name",
  LIKE: "opus_name",
  SOMETHING: "SOMETHING",
};

const IMG_IDX_MAP = {
  REELS: "image_id",
  LIKE: "image_id",
  SOMETHING: "SOMETHING",
};

interface IGalleryItem {
  photo: any;
  top: any;
  left: any;
  handleItemClicked: (id: string) => void;
  handleLike: (id: string, idx: number) => void;
  handleUnlike: (id: string, idx: number) => void;
  itemIdx: number;
  type: "REELS" | "LIKE" | "SOMETHING";
  seo?: boolean;
}

const GalleryItem: React.FC<IGalleryItem> = ({
  photo,
  top,
  left,
  itemIdx,
  handleItemClicked,
  handleLike,
  handleUnlike,
  type,
  seo = false,
}) => {
  const [hover, setHover] = useState<boolean>(false);

  const urlStr = photo[URL_IDX_MAP[type]];
  const title = photo[TITLE_IDX_MAP[type]];
  const setsId = photo[IMG_IDX_MAP[type]];

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };

  const handleCancelLikeClicked = async (e: any) => {
    e.stopPropagation();
    handleUnlike(setsId, itemIdx);
  };

  const handleLikeClicked = async (e: any) => {
    e.stopPropagation();
    handleLike(setsId, itemIdx);
  };

  const handleItemClick = (e: any) => {
    console.log("item click!");
    e.stopPropagation();
    handleItemClicked(setsId);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseOut}
      className={`${styles["gallery-item-wrapper"]}`}
      onClick={handleItemClick}
      style={{
        height: photo.height,
        width: photo.width,
        top: `${top}px`,
        left: `${left}px`,
      }}
    >
      <img
        alt={photo?.title}
        className={`${styles["gallery-item-img"]} ${hover && styles["gallery-item-img-hover"]}`}
        {...photo}
        src={`${urlStr}?x-oss-process=image/resize,w_${IMG_COMPRESSION_W}`}
        // onClick={handleClick}
      />
      {seo && <a href={`/arts/${photo.image_id}`} onClick={(e) => e.preventDefault()}></a>}
      {hover && <div className={styles["mask"]}></div>}
      {hover && (
        <div className={styles["gallery-item-bottom"]}>
          <div className={styles["bottom-left"]}>
            <img className={styles["bottom-left-img"]} src={photo.user_avatar} alt="" />
            <div className={styles["bottom-left-name"]}>{title}</div>
          </div>
          <div className={styles["bottom-right"]}>
            <div className={styles["like-icon-wrapper"]}>
              {photo.is_like ? (
                <IsLikingIcon onClick={handleCancelLikeClicked} />
              ) : (
                <LikeIcon onClick={handleLikeClicked} />
              )}
            </div>
            {photo.likes}
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryItem;
